export var StrategyAttributeWellKnownNames;
(function (StrategyAttributeWellKnownNames) {
    StrategyAttributeWellKnownNames["Device"] = "device";
    StrategyAttributeWellKnownNames["Country"] = "country";
    StrategyAttributeWellKnownNames["Platform"] = "platform";
    StrategyAttributeWellKnownNames["Userkey"] = "userkey";
    StrategyAttributeWellKnownNames["Session"] = "session";
    StrategyAttributeWellKnownNames["Version"] = "version";
})(StrategyAttributeWellKnownNames || (StrategyAttributeWellKnownNames = {}));
//# sourceMappingURL=strategy-attribute-well-known-names.js.map